import Markdown from 'react-markdown';
import styles from './Message.module.css';

function MessageContent(props: { messageContent: string }) {
    return (
        <Markdown className={styles.chatMessageContent} >{props.messageContent}</Markdown>
    )
}
export default MessageContent;